import { AutogenModelInvoiceNoLookup, AutogenRowInvoiceNoLookup } from "./autogen/AutogenModelInvoiceNoLookup";

export class ModelInvoiceNoLookup extends AutogenModelInvoiceNoLookup<RowInvoiceNoLookup> {
	constructor() {
		super(RowInvoiceNoLookup);
	}
}

export class RowInvoiceNoLookup extends AutogenRowInvoiceNoLookup {
}